<template>
  <div class="gmb-attributes-tree-node">
    <div class="items">
      <template v-for="(service, index) in testServices">
        <div class="item" :key="index">
          <GmbServicesItemBool
            :service="service"
            :delete-mode="deleteMode"
            @input="handleSelectedValue(service, index, $event)"
          />
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { GmbAttributeValueType } from "@/enums/gmb-attribute-value-type";
import GmbServicesItemBool from "@/components/FacilityDetails/GmbServices/GmbServicesItemBool";
import Vue from "vue";
export default {
  name: "GmbServicesMassTreeNode",
  components: {
    GmbServicesItemBool
  },
  props: {
    services: {
      type: Array,
      required: true
    },
    deleteMode: {
      type: Boolean,
      default: () => false
    }
  },
  data() {
    return {
      valueType: GmbAttributeValueType,
      selectedServices: {}
    };
  },
  computed: {
    testServices() {
      return this.services;
    }
  },
  methods: {
    handleSelectedValue(service, index, value) {
      this.selectedServices = { ...service, value };
      Vue.set(this.services, index, this.selectedServices);
      const onlyDeleted = this.services.filter(service => service.value);
      this.$emit("input", onlyDeleted);
    }
  }
};
</script>

<style lang="scss" scoped>
.gmb-attributes-tree-node {
  padding-top: 20px;
  padding-bottom: 15px;

  &:not(:last-of-type) {
    border-bottom: 1px solid rgba(0, 0, 0, 0.07);
  }
}
</style>
